export default __webpack_public_path__ + "static/media/empty_img.b5d0cd80.jpg";